export default class MainContactObj {
    phones
    name
    id
    emails
    description

    constructor () {
      this.phones = []
      this.emails = []
    }
}
